function hasFullAccess(UserInfo:any) {
    //console.log(`userInfo`,UserInfo);
    if(UserInfo && UserInfo.roles!=''){
        return UserInfo.roles.includes('admin');
      }else{
        return false;
      }
  }
  function getClaims(UserInfo:any){
    if(UserInfo && UserInfo.claims!=''){
        return UserInfo.claims.split(',');
      }else{
        return [];
      }
  }
  export { getClaims, hasFullAccess };

  